module.exports = __webpack_public_path__ + "static/media/Mariachi.d810e7fc.jpg";